<template>
    <div class="col-md-12">
        <base-button block type="default" class="icon icon-shape border-success bg-success rounded-circle text-white mt--6 float-right" @click="modalAdd = true">
            <i class="ni ni-fat-add"></i>
        </base-button>

        <modal :show.sync="modalAdd"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-xl">
            <base-header class="header pb-2 pb-2 pt-5 pt-md-8 d-flex align-items-center">
                <!-- Mask -->
                <span class="mask bg-gradient-login_varient opacity-8"></span>
                <!-- Header container -->
            </base-header>

            <div class="container-fluid mt--7">
                <div class="row">
                    <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Ajouter un fournisseur</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                
                                <h6 class="heading-small text-muted mb-4">Informations Générales</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Nom du fournisseur"
                                                        placeholder="Nom du fournisseur"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                                        v-model="fournisseur.nom"
                                            />
                                            <transition name="fade">
                                                <div  v-if="nomMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    Le nom est manquant.
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Informations Contact</h6>
                                <div class="pl-lg-4"> 
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Prénom du contact"
                                                        placeholder="Prénom du contact"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                                        v-model="fournisseur.prenomContact"
                                            />
                                            <transition name="fade">
                                                <div  v-if="prenomContactMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    Le prénom est manquant.
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Nom du contact"
                                                        placeholder="Nom du contact"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                                        v-model="fournisseur.nomContact"
                                            />
                                            <transition name="fade">
                                                <div  v-if="nomContactMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    Le nom du contact est manquant.
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Mail du contact"
                                                        placeholder="Mail du contact"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                                        v-model="fournisseur.emailContact"
                                            />
                                            <transition name="fade">
                                                <div  v-if="emailContactMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    L'email est manquant.
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Téléphone du contact"
                                                        placeholder="Téléphone du contact"
                                                        input-classes="form-control-alternative"
                                                        :required="required"
                                                        v-model="fournisseur.phoneContact"
                                            />
                                            <transition name="fade">
                                                <div  v-if="phoneContactMissing" 
                                                    class="alert alert-danger" 
                                                    role="alert">
                                                    Le téléphone est manquant.
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <base-button v-on:click="submitForm" type="success col-lg-12">Ajouter ce fournisseur</base-button><br><br>
                                <transition name="fade">
                                    <div  v-if="errorfournisseur" 
                                        class="alert alert-danger" 
                                        role="alert">
                                        Problème lors de l'ajout...
                                    </div>
                                    <div  v-if="goodfournisseur" 
                                        class="alert alert-success" 
                                        role="alert">
                                        Facture ajouté
                                    </div>
                                </transition>
                            </form>
                        </template>
                    </card>
                </div>
                </div>
                <br>
            </div>
        </modal>
    </div>
</template>
<script>
import constvar from '@/const'
import modal from "@/components/Modal";

export default {
    name: "FournisseurAddModal",
    components: {
        modal
    },
    data() {
      return {
        modalAdd: false,
        required: true,
        fournisseur: {
            nom: '',
            prenomContact: '',
            nomContact: '',
            emailContact: '',
            phoneContact: '',
        },
        errorfournisseur: false,
        goodfournisseur: false,
        nomMissing: 0,
        prenomContactMissing: 0,
        nomContactMissing: 0,
        emailContactMissing: 0,
        phoneContactMissing: 0,
      }
    },
    methods: {
        submitForm: async function() {
            if(!this.fournisseur.nom) { this.nomMissing = 1 } else { this.nomMissing = 0 }
            if(!this.fournisseur.prenomContact) { this.prenomContactMissing = 1 } else { this.prenomContactMissing = 0 }
            if(!this.fournisseur.nomContact) { this.nomContactMissing = 1 } else { this.nomContactMissing = 0 }
            if(!this.fournisseur.emailContact) { this.emailContactMissing = 1 } else { this.emailContactMissing = 0 }
            if(!this.fournisseur.phoneContact) { this.phoneContactMissing = 1 } else { this.phoneContactMissing = 0 }
            if(this.nomMissing || this.prenomContactMissing || this.nomContactMissing || this.emailContactMissing || this.phoneContactMissing) { return; }


            const params = new FormData();
            params.append('nom', this.fournisseur.nom);
            params.append('prenomContact', this.fournisseur.prenomContact);
            params.append('nomContact', this.fournisseur.nomContact);
            params.append('emailContact', this.fournisseur.emailContact);
            params.append('phoneContact', this.fournisseur.phoneContact);

    
            const response = await fetch(constvar.api_url+'fournisseur', {
                method: 'POST',
                credentials: 'include',
                body: params
            });
            const json = await response.json();
            if(json.id) {
                this.$emit('fournisseuradded', true)
                this.modalAdd = false
            } else {
                this.errorfournisseur = true
                setTimeout(()=>{
                this.errorfournisseur = false
                },3000);
            } 
        },
    },
    watch: {
    }
};
</script>
<style>
    .style-chooser .vs__dropdown-toggle {
        border: none;
    }
</style>